<template lang="pug">
    v-layout-form( :busy="busy" )
        v-toolbar-form( subtitle="Cartola de pago" title="General" )

        //
        crud-form( @calculate="changeForm" ref="form" @submitForm="submitForm" v-bind="formProps" )
            template( slot="appendContent" )
                v-toolbar-form( subtitle="Facturas a pagar" title="Detalle" )
                    v-btn( @click="toggleDialog" flat slot="items" ) agregar
                    v-btn( @click="submitTableDeleteAll" flat slot="items" ) limpiar
                crud-data-table( @delete="submitTableDelete" ref="table" :service="table.service" v-bind="tableProps" v-if="hasDetail" )
                v-layout( v-else )
                    v-flex( xs12 )
                        h3.pa-5.text-xs-center Haz click en "agregar" para añadir una(s) factura(s)...        
        //
        v-dialog( v-bind="dialogProps" v-model="dialog.open" )
            crud-data-table( ref="tableDialog" v-bind="tableDialogProps" )
                v-btn( @click="toggleDialog" color="secondary" slot="buttons" ) cancelar
                v-btn( @click="submitDialog" color="primary" slot="buttons" ) agregar
</template>

<script>
//
import { mapActions, mapState } from 'vuex'
//
import { CrudDataTable, CrudForm } from '@/components/reusable_components'
import { FormLayout } from '@/components/layouts'
import { FormToolbar } from '@/components/toolbars'
//
import AccountingBankModel from '@/models/General/AccountingBankCard'
import UserModel from '@/models/General/GUser'
//
import AccountingBankCardService from '@/services/api/accountingBankCard'
import UserService from '@/services/api/user'
import { getFetchDataFunction } from '@/services/api/DataTableService'
//
import { AccountingBankPaymentFields } from './fields'
import { AccountingBankPaymentDetailHeaders } from './headers'
import { AccountingBankPaymentDialogHeaders } from './headers'
//
const invoiceInclude = [
    'sl_service_order_as_affected',
    'sl_service_order_as_new',
    'sl_customer_account_movement',
    'sl_customer',
    'sl_customer_branch_offices',
    'sl_detail_sale_invoices.wh_product',
    'g_company',
    'g_state',
]
//
const invoiceAppend = ['account_receivable']
//
export default {
    components: {
        'crud-data-table': CrudDataTable,
        'crud-form': CrudForm,
        'v-layout-form': FormLayout,
        'v-toolbar-form': FormToolbar,
    },
    computed: {
        dialogProps() {
            return {
                contentClass: 'white',
                fullscreen: true,
            }
        },
        formProps() {
            return {
                disabled: !this.hasDetail,
                fields: this.form.fields,
                noPadding: true,
                submitText: 'Enviar pago',
            }
        },
        hasDetail() {
            return this.table.items.length > 0
        },
        tableProps() {
            return {
                checkable: true,
                class: 'pa-4',
                headers: AccountingBankPaymentDetailHeaders,
                filters: [],
                noSearchBox: true,
                showAll: true,
                showButton: () => false,
            }
        },
        tableDialogProps() {
            return {
                checkable: true,
                class: 'pa-4',
                headers: AccountingBankPaymentDialogHeaders,
                filters: [],
                noActions: true,
                noAutoWidth: true,
                noSearchBox: true,
                service: {
                    dtFetchData: getFetchDataFunction(
                        process.env.VUE_APP_API_ROUTE + '/sl_sale_invoice',
                        invoiceInclude,
                        invoiceAppend
                    ),
                },
            }
        },
    },
    data() {
        return {
            busy: false,
            dialog: {
                open: false,
            },
            form: {
                fields: AccountingBankPaymentFields,
            },
            table: {
                items: [],
                service: {
                    dtFetchData: () => ({
                        data: [],
                    }),
                },
            },
        }
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        changeForm({ field, value, vmodels }) {
            //
            const account = this.form.fields[0].options.data.find(
                ({ id }) => id === value
            )
            //
            switch (field) {
                case 'accounting_bank_card_chile_id':
                    vmodels.g_user_id = account.g_user_id
                    vmodels.deposit = account.deposit
                    vmodels.balance = account.balance
                    break
            }
        },
        mapAmount: sl_sale_invoice => ({
            ...sl_sale_invoice,
            amount_to_pay: 1,
        }),
        mapInvoice: sl_sale_invoice => ({
            sl_sale_invoice_id: sl_sale_invoice.id,
            amount: sl_sale_invoice.amount_to_pay,
        }),
        async reset() {
            //
            this.busy = true
            //
            this.form.fields[0].options.data = await AccountingBankCardService.fetchAll()
            this.form.fields[1].options.data = await UserService.fetchAll()
            //
            const account = this.form.fields[0].options.data.find(
                ({ id }) => this.$route.params.id == id
            )
            //
            this.form.fields[0].value = account.id
            this.form.fields[1].value = account.g_user_id
            this.form.fields[2].value =
                account.accounting_bank_card_branch_office.branch_office
            this.form.fields[3].value =
                account.accounting_bank_card_movement_detail.movement_detail
            this.form.fields[4].value = account.deposit
            this.form.fields[5].value = account.balance
            //
            this.form.fields = [...this.form.fields]
            //
            this.busy = false
        },
        resetTable() {
            this.table.service = {
                dtFetchData: () => ({
                    data: [...this.table.items],
                }),
            }
        },
        showSnackbar(type, title, message) {
            this.resetSnackbarState()
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        submitDialog() {
            //
            this.dialog.open = false
            this.table.items = [
                ...this.table.items,
                ...this.$refs.tableDialog.selected
                    .filter(select =>
                        this.table.items.every(item => item.id !== select.id)
                    )
                    .map(this.mapAmount),
            ]
            //
            this.$refs.tableDialog.checkAll()
            this.$refs.tableDialog.checkAll()
            //
            this.resetTable()
        },
        async submitForm() {
            //
            const {
                error,
                message,
                status,
            } = await AccountingBankCardService.generatePayment({
                payments: [
                    {
                        accounting_bank_card_chile_id: this.$refs.form.vmodels
                            .accounting_bank_card_chile_id,
                        invoices: this.table.items.map(this.mapInvoice),
                    },
                ],
            })
            //
            switch (status) {
                case 'success':
                    this.showSnackbar('success', 'Éxito', 'Pago realizado.')
                    this.$router.push('/accounting_bank_card')
                    break
                case 'error':
                    this.showSnackbar('error', 'Error.', error || message)
                    break
            }
        },
        submitTableDelete(id) {
            this.table.items = [
                ...this.table.items.filter(item => item.id !== id),
            ]
            this.resetTable()
        },
        submitTableDeleteAll() {
            this.table.items = []
            this.resetTable()
        },
        toggleDialog() {
            this.dialog.open = !this.dialog.open
        },
    },
    mounted() {
        this.reset()
    },
    beforeMount() {
        this.setTitleTopBar('Realizar pago desde cartola')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_INVOICE_PAYMENT_VIA_BANK_CARD'))
                ctx.$router.push('/')
        })
    },
}
</script>

